import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: '500px',
    display: 'inline-flex',
    flexDirection: 'column',
    borderRadius: '8px',
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.palette.shadow.cardBoxShadow,
  },
  image: {
    width: '100%',
    height: '5rem',
    objectFit: 'cover',
    display: 'flex',
    justifyContent: 'center',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: `2.1875rem ${theme.spacing(3)}px 1.75rem`,
    height: '200px',
    position: 'relative',
  },
  headline: {
    color: theme.palette.secondary.main,
    textAlign: 'center',
  },
  logo: {
    height: '3.75rem',
    width: '3.75rem',
    border: `1px solid ${theme.palette.primary.light}`,
    padding: '1px',
    background: theme.palette.primary.light,
    position: 'absolute',
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'center',
    flexShrink: 0,
    borderRadius: '50%',
    justifyContent: 'center',
    objectFit: 'cover',
    top: '-1.875rem',
  },
  field: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: theme.spacing(2),
    '&>svg': {
      viewBox: '8 0 24 24',
    },
  },
  fieldText: {
    ...theme.typography.caption,
    color: theme.palette.grey.dark,
  },
  ctaContainer: {
    marginTop: 'auto',
    height: '50px',
    bottom: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  dateRange: {
    textAlign: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(3),
    '& span': {
      ...theme.typography.caption,
      color: theme.palette.grey.dark,
    },
  },
  ctaButton: {
    width: '100%',
    height: '50px',
    padding: '0',
    borderTop: `1px solid ${theme.palette.grey.light}`,
    '&:hover': {
      color: theme.palette.offwhite.main,
      backgroundColor: theme.palette.primary.dark,
    },
  },
}))

export default useStyles
